export default __webpack_public_path__ + "static/media/fixture1_ok.88c39c3b.png";